// Umami (privacy-first, no cookies, no banner needed for EU).
// No-op when VITE_UMAMI_WEBSITE_ID is unset. Self-hosted users set
// VITE_UMAMI_SCRIPT_URL to their instance's /script.js endpoint.
const websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID as string | undefined;
// `||` (not `??`) so an empty-string env var also falls through to the
// default. Vite inlines `VITE_UMAMI_SCRIPT_URL=` (set-but-empty) as `""`,
// which `??` would keep — silently breaking analytics in production.
const scriptUrl =
  (import.meta.env.VITE_UMAMI_SCRIPT_URL as string | undefined) ||
  "https://cloud.umami.is/script.js";

if (websiteId && typeof document !== "undefined") {
  const script = document.createElement("script");
  script.defer = true;
  script.src = scriptUrl;
  script.dataset.websiteId = websiteId;
  document.head.appendChild(script);
}
